import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../../AbstractElements";
import { QuestionAlertTitle, QuestionsState } from "../../../../Constants/Constants";
import { QuestionAlertSubTitle } from "../../../../Data/BonusUi/SweetAlert";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const QuestionAlert = () => {
  const buttonStyle = Swal.mixin({
    customClass: {
      cancelButton: "btn-primary",
    },
    buttonsStyling: true,
  });
  const handleAlert = () => {
    buttonStyle.fire({
      text: "Are you sure you want to do this?",
      showCancelButton: true,
      cancelButtonText: "Aww yiss!",
      confirmButtonText: "oh noez!",
      confirmButtonColor: "gray",
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card className="height-equal">
        <CommonCardHeader title={QuestionAlertTitle} span={QuestionAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="primary" className="sweet-11" onClick={handleAlert}>
            {QuestionsState}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};
export default QuestionAlert;
